import { gql } from '@apollo/client'

export const userTourFindOne = gql`
  query UserTourFindOne($tour: String!) {
    userTourFindOne(tour: $tour) {
      exists
    }
  }
`
